<ng-container *transloco="let t">
  @if (isBrowser) {
  <div *ngIf="isDesktop">
    <div ngbDropdown #desktopDropdown="ngbDropdown"  class="dropdown-small me-2" container="body" (openChange)="onDesktopDropdownOpen($event)">
      <div ngbDropdownToggle>
        {{t(title)}}
      </div>
      <div ngbDropdownMenu class="month-picker p-0 mt-1">
        <div class="dropdown-holder">
          <div class="calendar-holder">
            <ng-container *ngTemplateOutlet="monthPicker"></ng-container>
          </div>
          <button class="btn btn-circle btn-secondary btn-teal btn-sm m-2 float-end"
                              (click)="onApply()">
            <i class="bi bi-search"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isDesktop">
    <button type="button" class="filter-chip"
            (click)="onOpenMobileFilter()">
      <span class="filter-chip__label">{{title}}</span>
      <img src="./assets/img/svg/chevron_down.svg" alt="Chevron down" class="cursor-pointer">
    </button>
  </div>

  <ng-template #offcanvasDateRef>
    <div class="offcanvas-header d-flex justify-content-end">
      <button type="button" class="btn-unstyled" data-bs-dismiss="offcanvas" aria-label="Close"
              (click)="onClose()">
        <img src="assets/img/svg/close-modal.svg" alt="Close modal" style="height: 37px; width: 37px;">
      </button>
    </div>
    <div class="offcanvas-body">
      <div class="container">
        <div class="pb-16">
          <span class="fs-18 fw-500">{{ title }}</span>
        </div>
        <ng-container *ngTemplateOutlet="monthPicker"></ng-container>
      </div>
    </div>
    <div class="offcanvas-footer">
      <div class="row">
        <div class="col">
          <app-button-alt [buttonColor]="'white'" [textColor]="'var(--teal-500)'"
                          [text]="t('app.common.filters.clearAll')" [borderColor]="'var(--teal-500)'"
                          (onClickCallback)="onClear()" [isFullWidth]="true"
                          [isDisabled]="false" [buttonHeight]="'44px'" [fontSize]="'14px'"></app-button-alt>
        </div>
        <div class="col">
          <app-button-alt [buttonColor]="'var(--teal-500)'" [textColor]="'white'"
                          [text]="t('app.register.to.race.apply')" [borderColor]="'var(--teal-500)'"
                          (onClickCallback)="onApply()" [isFullWidth]="true"
                          [isDisabled]="false" [buttonHeight]="'44px'" [fontSize]="'14px'"></app-button-alt>
        </div>
      </div>
    </div>
  </ng-template>


  <ng-template #monthPicker>
    <div class="month-picker-container">
      <div class="year-selector">
        <button (click)="prevYear()">‹</button>
        {{ currentYear }}
        <button (click)="nextYear()">›</button>
      </div>

      <div class="months-grid">
        <button
                *ngFor="let month of months; let i = index"
                class="month-btn"
                [class.in-range]="isInRange(i)"
                [disabled]="isDisabled(i)"
                (click)="selectMonth(i)">
          {{ month }}
        </button>
      </div>
    </div>
  </ng-template>
  }
</ng-container>


